module.exports = __webpack_public_path__ + "static/media/green.db1fd82f.png";